export default __webpack_public_path__ + "static/media/engageIcon2.7760a68c.svg";